import { formatCompactAmount } from '@/utils/utils'
import * as d3 from 'd3'
import * as dc from 'dc'

// "Volume by Status" bar chart (Overview tab). NOTE: hard-codes its own
// USD/EUR/JPY FX rate table instead of going through
// store.convertNotionalToBRL like the currency/KPI charts do - a
// pre-existing inconsistency, kept as-is (not unified) to avoid any
// numeric/visual change as part of this refactor.

// This chart only shows these 4 statuses - other raw status values (e.g.
// EXP.QUOTE) are excluded without altering the underlying crossfilter group.
const VISIBLE_STATUSES = ['REJECTED', 'NOTH.DONE', 'DEAL']

export function createStatusBarChart ({ el, ndx, chartGroup, width, color }) {
  const dim = ndx.dimension((d) => d.status)
  const xAxisDomain = VISIBLE_STATUSES

  const rawGroup = dim.group().reduceSum((d) => {
    const notional = +d.notional || 0
    const currency = d.currency
    if (currency === 'USD') return notional * 5.2
    if (currency === 'EUR') return notional * 6.3
    if (currency === 'JPY') return notional * 0.036
    return notional
  })
  const group = {
    all: () => rawGroup.all().filter((kv) => VISIBLE_STATUSES.includes((kv.key || '').toUpperCase())),
  }

  const chart = new dc.BarChart(el, chartGroup)
  chart
    .width(width)
    .height(250)
    .x(d3.scaleBand().domain(xAxisDomain))
    .xUnits(dc.units.ordinal)
    .elasticY(true)
    .brushOn(true)
    .margins({ left: 50, right: 30, top: 30, bottom: 50 })
    .dimension(dim)
    .controlsUseVisibility(true)
    .renderHorizontalGridLines(true)
    .renderVerticalGridLines(true)
    .group(group)
    .clipPadding(40)
    .renderLabel(true)
    .label((d) => {
      const total = d3.sum(group.all(), (kv) => kv.value)
      const percent = total > 0 ? (d.data.value / total) * 100 : 0
      return `${percent.toFixed(0)}%`
    })
    .colors(color)
  chart.yAxis().tickFormat((v)=>formatCompactAmount(v)).ticks(6)
  chart.render()
  return chart
}
